import { createSlice } from '@reduxjs/toolkit'

export const selectModalStack = (state) => state.modal

const initialState = []
export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      return state.concat(action.payload)
    },
    closeModal: (state, action) => {
      state.pop()
    },
    replaceModalStack: (state, action) => {
      return action.payload
    }
  }
})

export const { openModal, closeModal, replaceModalStack } = modalSlice.actions
